export const normalizePhotoUrl = (url) => String(url || '').trim();

export const parseAlbumLinks = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return [];

  return raw
    .split(/[,，\n\r]+/)
    .map((part) => part.trim())
    .filter((url) => url.startsWith('http://') || url.startsWith('https://'))
    .map((url) => ({
      url,
      source: 'import',
      label: '商品相簿',
      createdAt: new Date().toISOString(),
    }));
};

export const buildProductPhotos = (product = {}) => {
  const photos = [];
  const seen = new Set();

  const addPhoto = (photo, fallback = {}) => {
    const url = normalizePhotoUrl(typeof photo === 'string' ? photo : photo?.url);
    if (!url || seen.has(url)) return;

    seen.add(url);
    photos.push({
      url,
      source: photo?.source || fallback.source || 'url',
      label: photo?.label || fallback.label || '',
      isCover: Boolean(photo?.isCover || fallback.isCover),
      includeInImageSearch: photo?.includeInImageSearch !== false,
      createdAt: photo?.createdAt || fallback.createdAt || new Date().toISOString(),
    });
  };

  addPhoto(product.image, { source: 'main', label: '主圖', isCover: photos.length === 0 });
  (Array.isArray(product.photos) ? product.photos : []).forEach((photo) => addPhoto(photo));

  (Array.isArray(product.styleDetails) ? product.styleDetails : []).forEach((detail, index) => {
    addPhoto(detail?.image, {
      source: 'style',
      label: product.styles?.[index] ? `樣式：${product.styles[index]}` : '樣式圖',
    });
  });

  if (photos.length > 0 && !photos.some((photo) => photo.isCover)) {
    photos[0].isCover = true;
  }

  return photos;
};

export const getCoverPhotoUrl = (product = {}) => {
  const photos = buildProductPhotos(product);
  return photos.find((photo) => photo.isCover)?.url || photos[0]?.url || '';
};
